export const CardBuilder = ({
  id,
  finalImageURL,
  fileName,
  imageFileExtension,
  imageFileSize,
  isFileArchived,
  thumbNailURL,
  isCheck = [],
  handleSelectAll = () => {},
  isCheckAll = false,
  handleClick = () => {},
  handleAdd = () => {},
  handleAddThumb = () => {},
  downloaded = false,
  handleRemove = () => {},
  handleRemoveThumb = () => {},
}) => {
  return (
    <div className="check">
      <label className="cont">
        <input
          key={id}
          id={id}
          type="checkbox"
          className="box"
          value={finalImageURL}
          checked={isCheck.includes(id)}
          onChange={(e) => {
            handleClick(e);
            const isChecked = e.target.checked;
            const fileData =
              e.target.value + "$" + fileName + "$" + imageFileExtension + "$" + imageFileSize;
            if (isChecked) {
              handleAdd(fileData, isFileArchived,id);
              handleAddThumb(thumbNailURL);
              if (downloaded === true) {
                handleClick(e);
              }
            } else {
              handleRemove(fileData,id);
              handleRemoveThumb(thumbNailURL);
            }
          }}
        ></input>
      </label>
    </div>
  );
};

export const CardDownloadIcon = ({
  finalImageURL,
  isFileArchived,
  downloadProgress = {},
}) => {
  const entry = downloadProgress?.[finalImageURL];
  if (isFileArchived === "true") return null;

  const status = entry?.status ?? null;
  const percent = typeof entry?.percent === "number" ? entry.percent : null;

  const hideTooltip = status && status !== "completed";
  const showIcon = !status || status === "completed";

  const renderText = () => {
    if (status === "failed") return "Failed";
    if (status === "completed" || percent === 100) return "100%";
    if (typeof percent === "number") return `${percent}%`;
    return "…";
  };

  return (
    <span className={`downloadIconWrapper ${hideTooltip ? "hideTooltip" : ""}`}>
      {showIcon ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          viewBox="0 0 16 16"
          className="downloadIcon"
        >
          <path d="M.5 9.9a.5.5 0 0 1 .5.5v3.1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10.4a.5.5 0 0 1 1 0v3.1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V10.4a.5.5 0 0 1 .5-.5z" />
          <path d="M7.646 10.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 9.293V1.5a.5.5 0 0 0-1 0v7.793L5.354 7.146a.5.5 0 1 0-.708.708l3 3z" />
        </svg>
      ) : (
        <span
          className={`downloadProgressText ${status === "failed" ? "failed" : ""}`}
          title={status === "failed" ? entry?.error || "Failed" : undefined}
        >
          {renderText()}
        </span>
      )}
    </span>
  );
};

export const Metadata = ({
  FileNo,
  workOrderNumber,
  siteName,
  patchName,
  workOrderLineItemWorkType,
  workOrderLineItemNumber,
  serviceAppointmentNumber,
  dateOnImage,
  imageUploadedDateTime,
  dbInsertedDateTime,
  longitude,
  latitude,
  owner,
  fileDescription,
  fileName,
  imageFileExtension,
}) => {
  const formatToUK = (iso) => {
    if (!iso) return "";
    try {
      const d = new Date(iso);

      // Convert date to UK time (Europe/London), but DON'T show GMT/BST
      const formatted = new Intl.DateTimeFormat("en-GB", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: "Europe/London",
        timeZoneName: "short",
      }).format(d);

      return `${formatted}`;
    } catch {
      return iso;
    }
  };

  const formatGps = () => {
    const lon = longitude == null ? "0.00" : longitude;
    const lat = latitude == null ? "0.00" : latitude;
    return `${lon}   ${lat}`;
  };

  const formatFileName = () => {
    if (!fileName) return null;
    return fileName.includes(".")
      ? fileName
      : `${fileName}.${imageFileExtension}`;
  };

  return (
    <div className="metadata">
      <div className="row">
        <b>File No.:</b>
        <span>{FileNo}</span>
      </div>
      <div className="row">
        <b>WO No.:</b>
        <span>{workOrderNumber}</span>
      </div>
      {siteName && (
        <div className="row">
          <b>Site name:</b>
          <span>{siteName}</span>
        </div>
      )}
      {patchName && (
        <div className="row">
          <b>Patch name:</b>
          <span>{patchName}</span>
        </div>
      )}
      {workOrderLineItemWorkType && (
        <div className="row">
          <b>Work type.:</b>
          <span>{workOrderLineItemWorkType}</span>
        </div>
      )}
      <div className="row">
        <b>WOLI No.:</b>
        <span>{workOrderLineItemNumber}</span>
      </div>
      {serviceAppointmentNumber && (
        <div className="row">
          <b>SA No :</b>
          <span>{serviceAppointmentNumber}</span>
        </div>
      )}
      <div className="row">
        <b>Captured Date:</b>
        <span>{dateOnImage}</span>
      </div>
      <div className="row">
        <b>Upload Date/Time to AMS:</b>
        {/* <span>{dbInsertedDateTime}</span> */}
        <span title={dbInsertedDateTime || imageUploadedDateTime || undefined}>
          {dbInsertedDateTime
            ? formatToUK(dbInsertedDateTime)
            : imageUploadedDateTime
              ? formatToUK(imageUploadedDateTime)
              : "N/A"}
        </span>
      </div>
      <div className="row">
        <b>Gps Loc. :</b>
        <span>{formatGps()}</span>
      </div>
      <div className="row">
        <b>Field User Name:</b>
        <span>{owner}</span>
      </div>
      <div className="row">
        <b>File Description:</b>
        <span>{fileDescription}</span>
      </div>
      <div className="row">
        <b>Filename:</b>
        <span>{formatFileName()}</span>
      </div>
    </div>
  );
};
